export const prefersReducedMotion = () => {
  const mediaMatches:any = window.matchMedia('(prefers-reduced-motion: reduce)');
  if(mediaMatches && !mediaMatches.matches) {
    return false;
  }
  return true;
}